let initialState = {
    stateData: [],
    cityData: [],
    cuntryData: [],
    referalAddress: "",
}

export default function ( state = initialState, action ) {
    switch ( action.type ) {
        case 'STATE_DATA':
            return { ...state, stateData: action.payload };
        case 'CITY_DATA':
            return { ...state, cityData: action.payload };
        case 'CUNTRY_DATA':
            return { ...state, cuntryData: action.payload };
        case "REFERAL_ADDRESS":
            return { ...state, referalAddress: action.payload };
        default:
            return state
    }
}